import { Calculator, ShieldCheck, FileStack } from "lucide-react";
import { AnimatedSection } from "./AnimatedSection";

const SERVICES = [
  {
    id: "accounting",
    icon: Calculator,
    title: "Accounting & Returns",
    tagline: "We manage your daily numbers and ensure all your regulatory filings are submitted accurately.",
    points: ["Daily bookkeeping, Tally journal posting, and periodical voucher verification visits", "Timely filing of GST, PF, and ESI returns", "Income Tax Returns (ITR) for individuals, firms, and companies"],
  },
  {
    id: "auditing",
    icon: ShieldCheck,
    title: "Auditing & Legal Support",
    tagline: "We rigorously review your accounts and provide expert legal representation when needed.",
    points: ["Statutory auditing services", "Preparing books for audit and generating customized G-Sheet accounts", "Handling of legal cases managed by Mr. Ramesh, Advocate"],
  },
  {
    id: "secretarial",
    icon: FileStack,
    title: "Business Registrations",
    tagline: "We handle the complicated paperwork required to set up your business and protect your brand.",
    points: ["Company, GST, and PAN registrations", "Intellectual Property Rights registration and renewal", "Dedicated support for ongoing compliance"],
  },
];

export const Services = () => (
  <section id="services" className="bg-white py-24 md:py-32">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <AnimatedSection className="max-w-2xl mb-16">
        <p className="overline text-[#1E3A8A] mb-4">What We Do</p>
        <h2 className="font-serif text-4xl md:text-5xl tracking-tight text-[#0F172A]">
          Comprehensive financial support. Handled properly, every time.
        </h2>
      </AnimatedSection>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {SERVICES.map((s, i) => {
          const Icon = s.icon;
          return (
            <AnimatedSection
              key={s.id}
              delay={i * 0.12}
              data-testid={`service-card-${s.id}`}
              className="group border border-slate-200 rounded-2xl p-8 hover:-translate-y-1 hover:shadow-[0_20px_40px_rgba(10,17,40,0.08)] transition-all duration-300"
            >
              <div className="w-12 h-12 rounded-full bg-[#0A1128] flex items-center justify-center mb-6">
                <Icon size={20} className="text-[#C5A059]" />
              </div>
              <h3 className="font-serif text-2xl text-[#0F172A] mb-3">{s.title}</h3>
              <p className="text-slate-500 text-base mb-6 leading-relaxed">{s.tagline}</p>
              <ul className="space-y-3">
                {s.points.map((p, idx) => (
                  <li key={idx} className="text-base text-slate-600 flex gap-3 leading-relaxed">
                    <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-[#C5A059] shrink-0" />
                    {p}
                  </li>
                ))}
              </ul>
            </AnimatedSection>
          );
        })}
      </div>
    </div>
  </section>
);
